module.exports = __webpack_public_path__ + "img/checked-payment.3602430d.svg";